<template>
  <q-page fluid>
    <div class="row full-width">
      <div
        v-if="['Admin', 'Waves Manager'].includes(currentUserData.role)"
        class="col-12 col-sm-6 col-md-4 q-pa-md"
      >
        <q-card class="bg-accent4 q-pa-md statCard">
          <h6 class="text-white q-my-none">Total Competitions</h6>
          <h5
            v-if="competitionCountStats"
            class="text-white q-mt-none q-mb-lg"
            style="font-weight: 800"
          >
            {{ competitionCountStats.count | numberFormat }}
          </h5>
          <!-- <p class="text-white">This Season</p> -->

          <q-avatar size="45px" rounded color="white" class="statCardIcon">
            <q-icon color="accent4" name="mdi-swim" size="lg"></q-icon>
          </q-avatar>
        </q-card>
      </div>
      <div
        v-if="['Admin', 'Waves Manager'].includes(currentUserData.role)"
        class="col-12 col-sm-6 col-md-4 q-pa-md"
      >
        <q-card class="bg-accent3 q-pa-md statCard">
          <h6 class="text-white q-my-none">Total Athletes</h6>
          <h5
            v-if="athleteCountStats"
            class="text-white q-mt-none q-mb-lg"
            style="font-weight: 800"
          >
            {{ athleteCountStats.count | numberFormat }}
          </h5>
          <p v-if="athleteCountStats && false" class="text-white">
            {{
              percentFromPrevious(
                athleteCountStats.thisMonthsCount,
                athleteCountStats.lastMonthsCount
              ) > 0
                ? "+"
                : ""
            }}
            {{
              percentFromPrevious(
                athleteCountStats.thisMonthsCount,
                athleteCountStats.lastMonthsCount
              )
            }}% From Previous Month
          </p>
          <q-avatar size="45px" rounded color="white" class="statCardIcon">
            <q-icon color="accent3" name="mdi-account" size="lg"></q-icon>
          </q-avatar>
        </q-card>
      </div>

      <div
        v-if="['Admin', 'Waves Manager'].includes(currentUserData.role)"
        class="col-12 col-sm-6 col-md-4 q-pa-md statCard"
      >
        <q-card class="bg-primary q-pa-md">
          <h6 class="text-white q-my-none">Total Invoiced</h6>
          <h5 class="text-white q-mt-none q-mb-lg" style="font-weight: 800">
            ${{
              invoicedAmountStats.amount
                ? invoicedAmountStats.amount
                : 0 | number
            }}
          </h5>
          <p v-if="false" class="text-white">+x% From Previous Month</p>
          <q-avatar size="45px" rounded color="white" class="statCardIcon">
            <q-icon color="primary" name="mdi-cash" size="lg"></q-icon>
          </q-avatar>
        </q-card>
      </div>
      <div class="col-12 q-pa-md">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Welcome {{ currentUserData.name.split(" ")[0] }}
                <span
                  style="
                    font-size: 12px;
                    position: absolute;
                    left: 16px;
                    bottom: -5px;
                  "
                  class="text-grey"
                >
                  {{ currentUserData.role }} - This account allows you to manage
                  {{ userAccessLevelDescriptions[currentUserData.role] }}
                </span>
              </div>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section>
            <p>Welcome to your Event Management System!</p>
            <p>
              The Event Management System allows you to access various levels of
              event design, entries and waves competition management along with
              live results reporting. Use the left side menu bar to select the
              area to wish to start working on.
            </p>
            <p>
              You can edit your details by clicking on your name at the top left
              side menu.
            </p>
            <p>
              If you have any questions please don’t hesitate to contact us or
              use the help menu title to access system tutorials.
            </p>
            <p>Have a great day ;-)</p>
          </q-card-section>
        </q-card>
      </div>
      <div class="col-12 q-pa-md" v-if="false">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Calendar</div>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section> Comming Soon! </q-card-section>
        </q-card>
      </div>
      <div class="col-12 q-pa-md" v-if="false">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Competitions
              </div>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="dataLoading"
                @click="loadData"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="gridData">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 260px) !important"
                >
                  <datatable
                    :filter="search"
                    :flat="true"
                    :data="gridData"
                    :columns="columns"
                    @rowDoubleClick="handleDoubleClick"
                  >
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td
                        :class="{
                          currentlyDeployedTD: data.props.value == 1,
                          notDeployedTD: data.props.value != 1,
                        }"
                        :props="data.props"
                      >
                        <!-- <q-btn>Test</q-btn> -->
                        Coming soon!
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>

      <div
        v-if="currentUserData.hasGoogleLogin == 0"
        class="col-12 col-sm-6 q-mt-md"
      >
        <q-card>
          <q-card-section>
            <div style="display: inline-block" class="text-h6">
              Link Account with Google
            </div>
          </q-card-section>
          <q-card-section>
            <q-btn color="primary" @click="linkWithGoogle">
              Login with Google
            </q-btn>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import datatable from "@/components/datatable/datatable.vue";
  import moment from "moment";

  export default {
    components: { datatable },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        gridData: "competitions/list",
        dataLoading: "competitions/listLoading",
        eventCountStats: "stats/eventCountStats",
        competitionCountStats: "stats/competitionCountStats",
        invoicedAmountStats: "stats/competitionCountStats",

        athleteCountStats: "stats/athleteCountStats",
      }),
    },
    watch: {},
    data: () => ({
      // data-table
      columns: [
        {
          name: "competition_name",
          label: "Competition",
          align: "left",
          field: "competition_name",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
        {
          name: "start_date",
          label: "Start Date",
          align: "left",
          field: "start_date",
          format: (val) =>
            val != null ? moment(val).format("DD-MMM, YYYY") : "",
          sortable: true,
        },
        {
          name: "entriesCloseDate",
          label: "Entries Close Date",
          align: "left",
          field: "entriesCloseDate",
          format: (val) =>
            val != null ? moment(val).format("DD-MMM, YYYY") : "",
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "left",
          sortable: false,
        },
      ],
      search: "",

      userAccessLevelDescriptions: {
        Admin: "everything",
        "Waves Manager": "everything",
        "Sport Admin":
          "Design Competition Management, Entries, Waves, Live Results",
        "Club Admin":
          "Enter Competitions, Look up members, Users, reports, manage club access, Club info",
        "Team Manager": "Enter Competitions",
        Coach: "Enter Competitions",
        "Sports Coordinator": "Enter Competitions",
        "Junior Coordinator": "Enter Competitions",
        Athlete: "enter competitions when available",
        Official: "Waves",
      },
    }),
    mounted() {
      this.loadData();
    },
    methods: {
      loadData() {
        // this.$store.dispatch("stats/loadEventCount");
        this.$store.dispatch("stats/loadCompetitionCount");
        this.$store.dispatch("stats/loadAthleteCount");
        this.$store.dispatch("stats/loadInvoicedAmount");
        this.$store.dispatch("competitions/loadAll");
      },
      linkWithGoogle() {
        this.$store.dispatch("auth/linkWithGoogle");
      },
      handleDoubleClick(row) {
        this.$router.push(`/competitions/${row.id}`);
      },
    },
  };
</script>

<style lang="scss" >
  .statCardIcon {
    position: absolute !important;
    top: 25px !important;
    right: 15px !important;
    border-radius: 5px !important;
  }

  .statCard {
    height: 120px !important;
  }
</style>
